import React from 'react';
import PropTypes from 'prop-types';
import {translateDisplayKeyWithFallback} from '@elixir/translator';
import {ThemeProvider} from '@elixir/theme';
import {ModalProvider} from '@elixir/components';
import {Redirect, Route, Switch} from 'react-router-dom';
import uuid from 'uuid/v1';

import LoginForm from '../login/loginForm/loginForm';
import ForgotPassword from '../login/forgotPassword/forgotPassword';
import LandingContainer from '../landing/landingContainer';
import ResetPassword from '../login/resetPassword/resetPassword';

export default class AppComponent extends React.Component {

    constructor (props) {
        super(props);

        this.state = {
            theme: undefined
        };
    }

    componentDidMount () {
        const clientId = window.localStorage.getItem('clientId::operator');

        if (!clientId) {
            window.localStorage.setItem('clientId::operator', uuid());
        }
    }

    getChildContext () {
        return {
            translator: translateDisplayKeyWithFallback
        };
    }

    handleThemeChange = (newTheme) => {
        this.setState({theme: newTheme});
    };

    render () {
        return (
            <ThemeProvider>
                <ModalProvider id="modalProvider"/>

                <Switch>
                    <Route exact path="/" render={() => (
                        <Redirect to="/login"/>
                    )}/>
                    <Route path='/login' component={LoginForm}/>
                    <Route path='/forgotpassword' component={ForgotPassword}/>
                    <Route path='/password' component={ResetPassword}/>

                    <Route path='/app' component={LandingContainer}/>
                </Switch>

            </ThemeProvider>
        );
    }
}

AppComponent.childContextTypes = {
    translator: PropTypes.func.isRequired
};
